<div class="my-events-container">
  <h2 class="my-events-container__title">
    <i class="pi pi-calendar-plus"></i>
    Eventos que você produz
  </h2>

  <form class="my-events-container__filters" [formGroup]="filtersForm">
    <div class="my-events-container__filter-field my-events-container__filter-field--search">
      <label class="form-label" for="myEventsSearch">Buscar evento</label>
      <div class="my-events-container__search-input">
        <i class="pi pi-search"></i>
        <input
          id="myEventsSearch"
          type="text"
          class="form-control"
          formControlName="query"
          placeholder="Nome do evento" />
      </div>
    </div>

    <div class="my-events-container__filter-field">
      <label class="form-label" for="myEventsStatus">Situação</label>
      <select id="myEventsStatus" class="form-select" formControlName="status">
        <option value="">Todos</option>
        <option value="active">Ativos</option>
        <option value="ended">Encerrados</option>
      </select>
    </div>

    <div class="my-events-container__filter-field">
      <label class="form-label" for="myEventsMinRevenue">Faturamento mín. (R$)</label>
      <input
        id="myEventsMinRevenue"
        type="number"
        min="0"
        step="0.01"
        inputmode="decimal"
        class="form-control"
        formControlName="minRevenue"
        placeholder="0"
        (keydown)="blockInvalidNumberKeys($event)" />
    </div>

    <div class="my-events-container__filter-field">
      <label class="form-label" for="myEventsMaxRevenue">Faturamento máx. (R$)</label>
      <input
        id="myEventsMaxRevenue"
        type="number"
        min="0"
        step="0.01"
        inputmode="decimal"
        class="form-control"
        formControlName="maxRevenue"
        placeholder="Sem limite"
        (keydown)="blockInvalidNumberKeys($event)" />
    </div>

    @if (hasRevenueRangeError) {
      <p class="my-events-container__filter-error">
        <i class="pi pi-exclamation-circle"></i>
        O faturamento mínimo não pode ser maior que o máximo.
      </p>
    }

    @if (hasActiveFilters) {
      <button type="button" class="my-events-container__clear-btn" (click)="clearFilters()">
        <i class="pi pi-filter-slash"></i>
        Limpar filtros
      </button>
    }
  </form>

  <app-events-table
    [eventsPage]="myEvents$ | async"
    [showPagination]="true"
    [rows]="5"
    (pageChangeClick)="handlePageChange($event)" />
</div>
